import React, { useState, useEffect, useMemo } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, Image, Radio, Tooltip, Tag,
    InputNumber,
    Collapse,
    TimePicker
} from "antd";
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
    deleteTemplateEnergySaver, addTemplateEnergySaver, getTemplateEnergySaver
} from "../../../axios/api.device"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";
import dayjs from 'dayjs';

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentEnergySaver = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dataForm] = Form.useForm();
    const { t } = useTranslation();

    const [powerOn, setPowerOn] = useState<number>(0);
    const [powerOff, setPowerOff] = useState<number>(0);

    const S_OPTIONS = [
        { value: 0, label: "暂不设置" },
        { value: 1, label: "启用" }
    ];

    const TIME_INTERVAL_OPTIONS = [
        { value: 0, label: "从不" },
        { value: 1, label: "1 Minute" },
        { value: 2, label: "2 Minutes" },
        { value: 3, label: "3 Minutes" },
        { value: 5, label: "5 Minutes" },
        { value: 10, label: "10 Minutes" },
        { value: 15, label: "15 Minutes" },
        { value: 30, label: "30 Minutes" },
        { value: 60, label: "1 Hour" },
        { value: 120, label: "2 Hours" },
        { value: 180, label: "3 Hours" },
    ];

    const normalOptions = useMemo(() => {
        return S_OPTIONS.map(item => ({
        value: item.value,
        label: t(item.label),
        }));
    }, []);

    const intervalOptions = useMemo(() => {
        return TIME_INTERVAL_OPTIONS.map(item => ({
        value: item.value,
        label: t(item.label), // 在这里统一应用国际化
        }));
    }, []);

    var addClick = () => {
        setShowTable(2)
    }
    useEffect(() => {
        getDataInfo()
    }, [])
    const getDataInfo = () => {
        getTemplateEnergySaver(templateId).then((res) => {
            if (res && res != null && res.powerOn) {
                if(res.powerOn)
                {
                    setPowerOn(res.powerOn)
                    res.powerOnTime = res.powerOnTime ? dayjs().startOf('day').add(res.powerOnTime, 'minute') : null;
                }
                if(res.powerOff)
                {
                    setPowerOff(res.powerOff)
                    res.powerOffTime = res.powerOffTime ? dayjs().startOf('day').add(res.powerOffTime, 'minute') : null;
                }
                setShowTable(2)
                dataForm?.setFieldsValue(res);
            } else {
                setShowTable(1)
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                console.log(res);
                if (res.powerOnTime) {
                // 将 dayjs 对象转换为整数分钟数
                    res.powerOnTime = res.powerOnTime.hour() * 60 + res.powerOnTime.minute();
                }
                if (res.powerOffTime) {
                    res.powerOffTime = res.powerOffTime.hour() * 60 + res.powerOffTime.minute();
                }
                console.log(res);
                addTemplateEnergySaver(templateId, res).then(() => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    getDataInfo();
                })
            })
    }
    const deleteTemplateClick = () => {
        dataForm.validateFields().then(() => {
            deleteTemplateEnergySaver(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                dataForm.resetFields();
                getDataInfo();
            })
        })

    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle"> {t("电源节能")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (

                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置电源节能")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <Form
                            style={{ width: "90%", marginTop: 36 }}
                            layout="horizontal"
                            form={dataForm}
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 14 }}
                            initialValues={{ sleepDisabled: false, desktopSystemSleepTimer: 0, desktopDisplaySleepTimer: 0, 
                                desktopDiskSleepTimer: 0, desktopWakeonLAN: 1, desktopAutoRestartOnPowerLoss: 1,
                                batterySystemSleepTimer: 0, batteryDisplaySleepTimer: 0, 
                                batteryDiskSleepTimer: 0, batteryWakeonLAN: 1, batteryAutoRestartOnPowerLoss: 1,
                                portableSystemSleepTimer: 0, portableDisplaySleepTimer: 0, 
                                portableDiskSleepTimer: 0, portableWakeonLAN: 1, portableAutoRestartOnPowerLoss: 1,
                                powerOn: 0, powerOnDate: 127,  powerOnTime: dayjs('00:00', 'HH:mm'),
                                powerOff: 0, powerOffDate: 127,  powerOffTime: dayjs('00:00', 'HH:mm')
                              }}
                        >
                            <Item
                                label={t("允许电源键启用睡眠")}
                                name="sleepDisabled"
                            >
                                <Select style={{width:"40%"}}>
                                    <Select.Option value={true}>{t("启用")}</Select.Option>
                                    <Select.Option value={false}>{t("暂不设置")}</Select.Option>
                                </Select>
                            </Item>
                            <Collapse defaultActiveKey={['2', '3', '4']} destroyOnHidden={false}>
                                <Collapse.Panel header={t("台式机")} key={'1'}>
                                    <Item label={t("睡眠")} colon={false}>
                                    </Item>
                                    <Item
                                        label={t("在此时间后电脑进入睡眠")}
                                        name="desktopSystemSleepTimer"
                                    >
                                        <Select
                                            style={{ width: "40%" }}
                                            options={intervalOptions}
                                        >
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("在此时间后关闭电脑屏幕")}
                                        name="desktopDisplaySleepTimer"
                                    >
                                        <Select 
                                            style={{ width: "40%" }}
                                            options={intervalOptions}
                                        >
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("在此时间后磁盘进入睡眠")}
                                        name="desktopDiskSleepTimer"
                                    >
                                        <Select 
                                            style={{ width: "40%" }}
                                            options={intervalOptions}
                                        >
                                        </Select>
                                    </Item>
                                    <Item label={t("唤醒")} colon={false}>
                                    </Item>
                                    <Item
                                        label={t("接入有线网络")}
                                        name="desktopWakeonLAN"
                                    >
                                        <Select 
                                            style={{ width: "40%" }}
                                            options={normalOptions}
                                        >
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("电脑故障后自动重启")}
                                        name="desktopAutoRestartOnPowerLoss"
                                    >
                                        <Select 
                                            style={{ width: "40%" }}
                                            options={normalOptions}
                                        >
                                            <Select.Option value={1}>{t("启用")}</Select.Option>
                                            <Select.Option value={0}>{t("暂不设置")}</Select.Option>
                                        </Select>
                                    </Item>
                                </Collapse.Panel>
                                <Collapse.Panel header={t("笔记本（电池）")} key={'2'}>
                                    <Item label={t("睡眠")} colon={false}>
                                    </Item>
                                    <Item
                                        label={t("在此时间后电脑进入睡眠")}
                                        name="batterySystemSleepTimer"
                                    >
                                        <Select
                                            style={{ width: "40%" }}
                                            options={intervalOptions}
                                        >
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("在此时间后关闭电脑屏幕")}
                                        name="batteryDisplaySleepTimer"
                                    >
                                        <Select 
                                            style={{ width: "40%" }}
                                            options={intervalOptions}
                                        >
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("在此时间后磁盘进入睡眠")}
                                        name="batteryDiskSleepTimer"
                                    >
                                        <Select 
                                            style={{ width: "40%" }}
                                            options={intervalOptions}
                                        >
                                        </Select>
                                    </Item>
                                    <Item label={t("唤醒")} colon={false}>
                                    </Item>
                                    <Item
                                        label={t("接入有线网络")}
                                        name="batteryWakeonLAN"
                                    >
                                        <Select 
                                            style={{ width: "40%" }}
                                            options={normalOptions}
                                        >
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("电脑故障后自动重启")}
                                        name="batteryAutoRestartOnPowerLoss"
                                    >
                                        <Select 
                                            style={{ width: "40%" }}
                                            options={normalOptions}
                                        >
                                            <Select.Option value={1}>{t("启用")}</Select.Option>
                                            <Select.Option value={0}>{t("暂不设置")}</Select.Option>
                                        </Select>
                                    </Item>
                                </Collapse.Panel>
                                <Collapse.Panel header={t("笔记本（插电）")} key={'3'}>
                                    <Item label={t("睡眠")} colon={false}>
                                    </Item>
                                    <Item
                                        label={t("在此时间后电脑进入睡眠")}
                                        name="portableSystemSleepTimer"
                                    >
                                        <Select
                                            style={{ width: "40%" }}
                                            options={intervalOptions}
                                        >
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("在此时间后关闭电脑屏幕")}
                                        name="portableDisplaySleepTimer"
                                    >
                                        <Select 
                                            style={{ width: "40%" }}
                                            options={intervalOptions}
                                        >
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("在此时间后磁盘进入睡眠")}
                                        name="portableDiskSleepTimer"
                                    >
                                        <Select 
                                            style={{ width: "40%" }}
                                            options={intervalOptions}
                                        >
                                        </Select>
                                    </Item>
                                    <Item label={t("唤醒")} colon={false}>
                                    </Item>
                                    <Item
                                        label={t("接入有线网络")}
                                        name="portableWakeonLAN"
                                    >
                                        <Select 
                                            style={{ width: "40%" }}
                                            options={normalOptions}
                                        >
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("电脑故障后自动重启")}
                                        name="portableAutoRestartOnPowerLoss"
                                    >
                                        <Select 
                                            style={{ width: "40%" }}
                                            options={normalOptions}
                                        >
                                            <Select.Option value={1}>{t("启用")}</Select.Option>
                                            <Select.Option value={0}>{t("暂不设置")}</Select.Option>
                                        </Select>
                                    </Item>
                                </Collapse.Panel>
                                <Collapse.Panel header={t("计划周期")} key={'4'}>
                                    <Item
                                        label={t("开机计划")}
                                        name="powerOn"
                                    >
                                        <Select
                                            style={{ width: "40%" }}
                                            options={normalOptions}
                                            onChange={(key: number) => {
                                                setPowerOn(key);
                                            }}
                                        >
                                        </Select>
                                    </Item>
                                    { powerOn == 1 && <> <Item
                                        label={t("日期")}
                                        name="powerOnDate"
                                        rules={[
                                        { 
                                            required: true, 
                                            message: '请选择执行日期！' 
                                        },
                                        ]}
                                    >
                                        <Select 
                                            style={{ width: "40%" }}
                                        >
                                             <Select.Option value={127}>{t("每天")}</Select.Option>
                                             <Select.Option value={31}>{t("工作日")}</Select.Option>
                                             <Select.Option value={96}>{t("周末")}</Select.Option>
                                             <Select.Option value={1}>{t("周一")}</Select.Option>
                                             <Select.Option value={2}>{t("周二")}</Select.Option>
                                             <Select.Option value={4}>{t("周三")}</Select.Option>
                                             <Select.Option value={8}>{t("周四")}</Select.Option>
                                             <Select.Option value={16}>{t("周五")}</Select.Option>
                                             <Select.Option value={32}>{t("周六")}</Select.Option>
                                             <Select.Option value={64}>{t("周日")}</Select.Option>
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("时间")}
                                        name="powerOnTime"
                                        rules={[
                                        { 
                                            required: true, 
                                            message: '请选择执行时间！' 
                                        },
                                        ]}
                                    >
                                        <TimePicker format="HH:mm" placeholder="请选择执行时间"  />
                                    </Item>
                                    </>}
                                    <Item
                                        label={t("关机计划")}
                                        name="powerOff"
                                    >
                                        <Select
                                            style={{ width: "40%" }}
                                            options={normalOptions}
                                            onChange={(key: number) => {
                                                setPowerOff(key);
                                            }}
                                        >
                                        </Select>
                                    </Item>
                                    { powerOff == 1 && <> <Item
                                        label={t("日期")}
                                        name="powerOffDate"
                                        rules={[
                                        { 
                                            required: true, 
                                            message: '请选择执行日期！' 
                                        },
                                        ]}
                                    >
                                        <Select 
                                            style={{ width: "40%" }}
                                        >
                                             <Select.Option value={127}>{t("每天")}</Select.Option>
                                             <Select.Option value={31}>{t("工作日")}</Select.Option>
                                             <Select.Option value={96}>{t("周末")}</Select.Option>
                                             <Select.Option value={1}>{t("周一")}</Select.Option>
                                             <Select.Option value={2}>{t("周二")}</Select.Option>
                                             <Select.Option value={4}>{t("周三")}</Select.Option>
                                             <Select.Option value={8}>{t("周四")}</Select.Option>
                                             <Select.Option value={16}>{t("周五")}</Select.Option>
                                             <Select.Option value={32}>{t("周六")}</Select.Option>
                                             <Select.Option value={64}>{t("周日")}</Select.Option>
                                        </Select>
                                    </Item>
                                    <Item
                                        label={t("时间")}
                                        name="powerOffTime"
                                        rules={[
                                        { 
                                            required: true, 
                                            message: '请选择执行时间！' 
                                        },
                                        ]}
                                    >
                                        <TimePicker format="HH:mm" placeholder="请选择执行时间"  />
                                    </Item>
                                    </>}
                                </Collapse.Panel>
                            </Collapse>
                        </Form>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
        </div>

    </>)
};